import { z } from "zod";

export const RejectionMappingAttributeSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
  pushNotificationTemplate: z.string().optional(),
  emailSubject: z.string().optional(),
  emailTemplate: z.string().optional(),
  pushNotificationEnabled: z.boolean().optional(),
  emailNotificationEnabled: z.boolean().optional(),
});

export type RejectionMappingAttributeType = z.infer<typeof RejectionMappingAttributeSchema>;

// FIXME: Automatically disabled during ESLint config update
const CreateOrPatchRejectionMappingRequestSchema = z.object({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data: z.object({
    attributes: RejectionMappingAttributeSchema,
    type: z.string(),
  }),
});
export type CreateOrPatchRejectionMappingRequestType = z.infer<
  typeof CreateOrPatchRejectionMappingRequestSchema
>;

// FIXME: Automatically disabled during ESLint config update
const RejectionMappingSchema = z.object({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data: z.object({
    attributes: RejectionMappingAttributeSchema,
    type: z.string(),
    id: z.string(),
  }),
});
export type RejectionMappingType = z.infer<typeof RejectionMappingSchema>;

export const RejectionMappingsSchema = z.object({
  data: z.array(
    z.object({
      type: z.string(),
      attributes: RejectionMappingAttributeSchema,
      id: z.string(),
    })
  ),
});
export type RejectionMappingsType = z.infer<typeof RejectionMappingsSchema>;
